import { Skeleton } from "@mui/material";

export const PageHeaderSkeleton = () => {
    return (
        <header className="flex items-center justify-between border-0 border-b border-solid border-gray-200 h-12">
            <div className="flex items-center gap-x-2 py-2 px-3">
                <Skeleton variant="circular" width={16} height={16} />
                <Skeleton variant="text" width={150} height={24} />
            </div>
        </header>
    );
};
